import UserPermissions from 'types/rbac';

const ENCRYPTION_KEY = '0mOvLK77kXrFovyvL9CxtksLyxPRrLSSntZiGE3Q0o4=';

const getEncryptionKey = () => {
  const binaryString = atob(ENCRYPTION_KEY);
  return new Uint8Array([...binaryString].map((char) => char.charCodeAt(0)));
};

export const storePermissions = async (permission: UserPermissions) => {
  const encryptedPermission = await encryptData(JSON.stringify(permission));
  localStorage.setItem('userPermissions', encryptedPermission);
};

export const getPermissions = async (): Promise<UserPermissions | null> => {
  const encryptedPermission = localStorage.getItem('userPermissions');
  if (!encryptedPermission) return null;
  const decryptedPermission = await decryptData(encryptedPermission);
  return decryptedPermission ?? null;
};

const encryptData = async (data: string) => {
  const iv = crypto.getRandomValues(new Uint8Array(12)); // Random IV
  const key = await crypto?.subtle?.importKey(
    'raw',
    getEncryptionKey(),
    { name: 'AES-GCM' },
    false,
    ['encrypt'],
  );
  const encrypted = await crypto?.subtle?.encrypt(
    { name: 'AES-GCM', iv },
    key,
    new TextEncoder().encode(data),
  );
  return JSON.stringify({
    iv: Array.from(iv).toString(),
    data: Array.from(new Uint8Array(encrypted)).toString(),
  });
};

const decryptData = async (encryptedData: string) => {
  try {
    const { iv, data } = JSON.parse(encryptedData);
    const key = await crypto?.subtle?.importKey(
      'raw',
      getEncryptionKey(),
      { name: 'AES-GCM' },
      false,
      ['decrypt'],
    );
    const decrypted = await crypto?.subtle?.decrypt(
      { name: 'AES-GCM', iv: new Uint8Array(iv.split(',').map(Number)) },
      key,
      new Uint8Array(data.split(',').map(Number)),
    );
    return JSON.parse(new TextDecoder().decode(decrypted));
  } catch (error) {
    console.error('Decryption failed:', error);
    return null;
  }
};
